import { type TextProps } from "@chakra-ui/react";

export const FILTER_LABEL_TEXT_PROPS: TextProps = {
  p: "0",
  m: "0",
  fontSize: "sm",
  fontWeight: "md",
};
